var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"scroll-top-button",on:{"click":_vm.scrollToTop}},[_c('img',{attrs:{"src":require("../assets/images/BringAutoFleet grafika-TOP.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }